import { DateTime } from "luxon"

export function getMatrixTypes() {
  return ["matrix", "matrixcheckbox"]
}

export function isMatrixQuestionType(type) {
  return getMatrixTypes().includes(type)
}

export function formatCompletedDateToLocaleString(date) {
  if (date) {
    //Note: This will convert the date value to the user's local timezone at 00:00:00 and then format it as a simple date string.
    //This is correct, as the date value should not move with timezone changes
    let dateObj = DateTime.fromISO(date)

    if (!dateObj.isValid && date instanceof Date && !isNaN(date)) {
      dateObj = DateTime.fromJSDate(date)
    }

    return dateObj.toLocaleString()
  } else {
    return date
  }
}
